












import { mapMutations, mapGetters } from 'vuex'
import Vue from 'vue'
import * as qs from 'qs'

export default Vue.extend({
  name: 'AmataBanner',
  data() {
    return {
      banners: {},
      isActive: false,
      isShowPadding: false
    }
  },
  computed: {
    ...mapGetters('Banner', ['bannerEntries', 'path'])
  },
  async created() {
    if (Object.keys(this.bannerEntries).length > 0 && this.bannerEntries[this.$route.name]) {
      // キャッシュ済みの banner が1つ以上ある場合だけ padding を事前に表示
      this.isActive = Object.keys(this.bannerEntries[this.$route.name]).length > 0
    }

    this.banners = this.bannerEntries[this.$route.name]
    this.fetchData()
  },
  methods: {
    ...mapMutations('Banner', ['setBannerEntries', 'setPath']),

    /**
     * サーバからデータを取得
     */
    async fetchData() {
      const res = await this.$http.post(
        '/page_banner/',
        qs.stringify({
          page: 'get_init',
          path: this.$route.name
        })
      )
      if (res.data.banners) {
        this.isActive = Object.keys(res.data.banners).length !== 0

        if (JSON.stringify(this.banners) !== JSON.stringify(res.data.banners)) {
          this.setBannerEntries({
            key: this.$route.name,
            banners: res.data.banners
          })
          this.setPath(this.$route.name)
          this.banners = this.bannerEntries[this.$route.name]
        }
      }
    },

    /**
     * バナーをクリック
     */
    onClick(link: string) {
      if (~link.indexOf('https://')) {
        this.$_open(link + this.$_appBrowserQuery)
      } else {
        this.$router.push(link)
      }
    }
  }
})
